/**
 * @typedef {{tag:string,text:[string],els:Array.<mkEl>,prop:object,attr:object}} mkEPar
 */
/**
 * @param {mkEPar|Object|String} par
 * @returns {mkE.Base|Node|null}
 */
function mkE(par) {
	if (!par.tag && typeof par.text !== 'string') {
		if (typeof par === 'string') {
			return document.createTextNode(par);
		}
		return null;
	}
	let elm;
	if (par.tag) {
		par.prop = par.prop || {};
		par.attr = par.attr || {};
		// set properties
		switch (par.tag) {
			case 'a':
				if (!par.href && !par.prop.href) {
					par.href = 'javascript:';
				} else {
					let target = par.target || par.attr.target;
					let href = par.href || par.prop.href;
					if (!par.attr.rel && target === '_blank' && D.rootDomain(href) !== D.rootDomain(document.location.host)) {
						par.attr.rel = (par.attr.rel ? par.attr.rel + ' ' : '') + 'noreferrer noopener';
					}
				}
				break;
			case 'input':
				if (par.type && par.type === 'checkbox' && (par.checked || par.prop.checked)) {
					par.defaultChecked = true;
				}
				break;
		}
		let _tag = par.tag;
		if (mkE._isOldIE) {
			if (par.prop.name || par.tag === 'input') {
				par.tag = '<' + par.tag +
					(par.name || par.prop.name ? ' name="' + (par.name || par.prop.name) + '"' : '') +
					(par.checked || par.prop.checked ? ' checked="checked"' : '') +
					(par.type || par.prop.type ? ' type="' + (par.type || par.prop.type) + '"' : '') +
					' />';
			}
		}
		try {
			elm = document.createElement(par.tag);
		} catch (e) {
			if (_tag !== par.tag) {
				elm = document.createElement(_tag);
			}
		}
		if (par.attr) {
			for (let key in par.attr) {
				elm.setAttribute(key, par.attr[key]);
			}
		}
		if (par.text_) {
			elm.appendChild(document.createTextNode(par.text_));
		}
		// append childs
		if (par.els && typeof par.els === 'object') {
			let r, ii;
			let els = par.els;
			if (!(els instanceof Array)) {
				els = [];
				for (ii in par.els) {
					if (par.els.hasOwnProperty(ii)) {
						els.push(par.els[ii]);
					}
				}
			}
			for (ii = 0; ii < els.length; ++ii) {
				r = els[ii];
				if (r instanceof Function) {
					r = r();
				}
				switch (typeof r) {
					case 'number':
						elm.appendChild(document.createTextNode(String(r)));
						continue;
					case 'string':
						elm.appendChild(document.createTextNode(r));
						continue;
					case 'object':
						if (!r) { // null
							continue;
						}
						if (!r.nodeType && (r.tag || r.text)) {
							r = mkE(r);
							break;
						}
						if (r instanceof Array) {
							for (let i = 0; i < r.length; ++i) {
								mkE.appendTypeElement(elm, r[i]);
							}
							continue;
						}
						break;
					case 'boolean': // skipjam false childus
						continue;
					case 'undefined':
						if (D.console) {
							D.console.error('Undefined child', par);
						}
						continue;
				}
				if (r.append && elm.append !== r.append) {
					r.append(elm);
				} else {
					elm.appendChild(r);
				}
			}
		}
		if (par.els && typeof par.els === 'string') {
			par.innerHTML = par.els;
		}
		O2O(elm, par.prop);
		if (typeof par.text !== 'undefined') {
			elm.appendChild(document.createTextNode(par.text));
		}
		elm.append = mkE.append;
		elm.appendTo = mkE.appendTo;
		elm.prepend = mkE.prepend;
		elm.remove = elm.remove || mkE.remove;
		if (D.animate) {
			elm.animate = D.animate;
		}
		elm.replace = mkE.replace;
	} else {
		elm = document.createTextNode(par.text);
	}
	for (let k in par) {
		let v = par[k];
		switch (k) {
			case 'tag':
			case 'text':
			case 'els':
			case 'prop':
			case 'attr':
			case 'text_':
			case 'append':
			case 'remove':
			case 'replace':
				break;
			default:
				if (k in elm) {
					if (v && v.constructor == Object) {
						O2O(elm[k], par[k]);
					} else {
						try {
							elm[k] = par[k];
						} catch (e) {
							if (window.D && D.console) D.console.error(e);
						}
					}
				} else if (window.D && D.DEV) {
					// touch events depend on device
					if( !in_array(k, ['ontouchstart', 'ontouchend', 'ontouchmove']) && v !== null ) {
						D.console.warn('mkE par[' + k + '] ?', par);
					}
				}
		}
	}
	// IE 11 fix
	if (par.tag === 'input' && (par.type || par.prop.type) && isset(par.value || par.prop.value)) {
		elm.value = par.value || par.prop.value;
	}
	return elm;
}

try {
	mkE._isOldIE = Boolean(navigator.appVersion.match(/MSIE [78]/));
} catch (e) {
}

mkE.append = function (node) {
	if (typeof node === 'string') {
		node = document.getElementById(node);
	}
	node.appendChild(this);
	/*if( this.onAppend ){
		this.onAppend();
	}*/
	return this;
};

mkE.prepend = function (node) {
	if (typeof node === 'string') {
		node = document.getElementById(node);
	}
	if (node.firstChild) {
		D.insertBefore(this, node.firstChild);
		return this;
	}
	node.appendChild(this);
	return this;
};
mkE.remove = function () {
	removeNode(this);
	return this;
};
mkE.clear = function () {
	clearNode(this);
	return this;
};
/**
 * @typedef {Node|mkEPar|number|string|object|Function} mkEl
 */


/**
 * @param {Node} elm
 * @param {mkEl|Array.<mkEl>} r
 */
mkE.appendTypeElement = function (elm, r) {
	if (r instanceof Function) {
		r = r();
	}
	switch (typeof r) {
		case 'number':
			elm.appendChild(document.createTextNode(String(r)));
			return;
		case 'string':
			elm.appendChild(document.createTextNode(r));
			return;
		case 'object':
			if (!r) { // null
				return;
			}
			if (!r.nodeType && (r.tag || r.text)) {
				r = mkE(r);
				break;
			}
			if (r instanceof Array) {
				for (let i = 0; i < r.length; ++i) {
					mkE.appendTypeElement(elm, r[i]);
				}
				return;
			}
			break;
		case 'boolean': // skipjam false childus
			return;
		case 'undefined':
			D.console.error('Undefined child', par);
			return;
	}
	if (r.append) {
		r.append(elm);
	} else {
		elm.appendChild(r);
	}
};

mkE.replace = function (node) {
	if (typeof node === 'string') {
		node = document.getElementById(node);
	}
	if (!node.parentNode) {
		return this;
	}
	D.insertBefore(this, node);
	removeNode(node);
	return this;
};

mkE.Base = function () {
};

mkE.Base.prototype = {

	append: function (parent) {
		if (typeof parent === 'string') {
			parent = document.getElementById(parent);
		}
		this.node.append(parent);
		return this;
	},

	remove: function () {
		this.node.remove();
		return this;
	},

	replace: function (node) {
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		D.insertBefore(this.node, node);
		removeNode(node);
		return this;
	},

	prepend: function (node) {
		if (typeof node === 'string') {
			node = document.getElementById(node);
		}
		if (node.firstChild) {
			D.insertBefore(this.node, node.firstChild);
			return this;
		}
		node.appendChild(this.node);
		return this;
	}

};

function removeNode(node) {
	if (node && node.parentNode && node.parentNode.tagName) {
		return node.parentNode.removeChild(node);
	} else {
		return false;
	}
}

function clearNode(node) {
	let n;
	while (n = node.firstChild) {
		if (n.remove) {
			n.remove();
			continue;
		}
		removeNode(n);
	}
	return node;
}

/**
 * @param {Node} node
 * @param {string} className
 * @returns {Node}
 */
function addClassName(node, className) {
	if (node.classList) {
		let cl = className.split(/\s/);
		for (let k = 0, l = cl.length; k < l; k++) {
			if (!cl[k]) {
				continue;
			}
			node.classList.add(cl[k]);
		}
		return node;
	}
	let cn = node.className.split(' ');
	let is = false;
	let i;
	for (i = 0; i < cn.length; i++) {
		if (cn[i] === className) {
			is = true;
		}
	}
	if (!is) {
		cn.push(className);
	}
	node.className = cn.join(' ');
	return node;
}

/**
 * @param {Node} node
 * @param {string} className
 * @returns {Node}
 */
function removeClassName(node, className) {
	if (node.classList) {
		let cl = className.split(/\s/);
		for (let k = 0, l = cl.length; k < l; k++) {
			if (!cl[k]) {
				continue;
			}
			node.classList.remove(cl[k]);
		}
		return node;
	}
	let cn = node.className.split(' ');
	let cnr = [];
	let found = false;
	for (let i = 0; i < cn.length; i++) {
		if (cn[i] === className) {
			found = true;
		} else {
			cnr.push(cn[i]);
		}
	}
	if (found) {
		node.className = cnr.join(' ');
	}
	return node;
}

/**
 * @param {Node} node
 * @param {string} className
 * @returns {boolean}
 */
function existsClassName(node, className) {
	if (node.classList) {
		return node.classList.contains(className);
	}
	let cn = node.className.split(' ');
	for (let i = 0; i < cn.length; i++) {
		if (cn[i] === className) {
			return true;
		}
	}
	return false;
}

function toggleClassName( node, className, toggle = null ) {
	if( toggle === null ) {
		toggle = !existsClassName(node, className);
	}
	if( !toggle ) {
		return removeClassName(node, className);
	}
	return addClassName(node, className);
}

function getNodeText(node) {
	if (typeof node.textContent === 'string') {
		return node.textContent;
	} else if (typeof node.innerText === 'string') {
		return node.innerText;
	} else {
		return node.innerHTML;
	}
}

function nextElementSibling(node) {
	if (node.nextElementSibling) {
		return node.nextElementSibling;
	}

	do {
		node = node.nextSibling;
	} while (node && node.nodeType !== Node.ELEMENT_NODE);

	return node;
}

function setNodeText(node, text) {
	if (typeof node.textContent === 'string') {
		node.textContent = text;
	} else if (typeof node.innerText === 'string') {
		node.innerText = text;
	} else {
		while (node.firstChild) {
			node.removeChild(node.firstChild);
		}
		node.appendChild(node.createTextNode(text));
	}
}

function findPosX(obj, parent) {
	if (!obj) {
		return 0;
	}
	var curleft = 0;
	if (obj.getBoundingClientRect) {
		curleft = Math.round(obj.getBoundingClientRect().left);
	} else if (obj.offsetParent) {
		while (obj.offsetParent) {
			curleft += obj.offsetLeft;
			if (obj.offsetParent === parent) {
				break;
			}
			obj = obj.offsetParent;
		}
	} else if (obj.x) {
		curleft += obj.x;
	}
	return curleft;
}

function findPosY(obj, parent) {
	if (!obj) {
		return 0;
	}
	var curtop = 0;
	if (obj.offsetParent) {
		while (obj.offsetParent) {
			curtop += obj.offsetTop;
			if (obj.offsetParent === parent) {
				break;
			}
			obj = obj.offsetParent;
		}
	} else if (obj.y) {
		curtop += obj.y;
	}
	return curtop;
}

/**
 * @param {HTMLDocument} [context=document]
 * @returns {HTMLElement}
 */
function getHeadElement(context) {
	context = context || document;
	return context.head || context.getElementsByTagName('head')[0];
}

/**
 * @param el newNode
 * @param before referenceNode
 */
D.insertBefore = function (el, before) {
	if (!before) {
		if (D.DEV) {
			D.console.error('no before node');
		}
		return;
	}
	before.parentNode.insertBefore(el, before);
};

D.insertAfter = function (el, node) {
	if (node.nextSibling) {
		D.insertBefore(el, node.nextSibling);
	} else {
		node.parentNode.appendChild(el);
	}
};

if (typeof Node === 'undefined') {
	(function () {
		let k = 'No' + 'de'; // for IDE
		window[k] = function () {
		};
		window[k].ELEMENT_NODE = 1;
		window[k].TEXT_NODE = 3;
		window[k].COMMENT_NODE = 8;
	})();
}

function mkELottie(par, options) {
	let el = mkE(par);
	options.container = el;
	D.lottie(options);
	return el;
}